(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bike-coverflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCoverflow(stage) {
      if (!stage || stage.dataset.bcfReady) return;
      stage.dataset.bcfReady = '1';

      var track = stage.querySelector('[data-bcf-track]');
      var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-bcf-slide]'));
      var prevBtn = stage.querySelector('[data-bcf-prev]');
      var nextBtn = stage.querySelector('[data-bcf-next]');
      var dotsWrap = stage.parentNode.querySelector('[data-bcf-dots]');
      var n = slides.length;
      if (!n) return;

      var active = Math.floor(n / 2) >= 0 ? 0 : 0;
      active = 0;

      // Build dots
      var dots = [];
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bcf__dot';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { setActive(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function norm(off) {
        off = ((off % n) + n) % n;
        if (off > n / 2) off -= n;
        return off;
      }

      function layout() {
        slides.forEach(function (slide, i) {
          var off = norm(i - active);
          var abs = Math.abs(off);
          var tx, sc, op, z, show;

          if (off === 0) {
            tx = 0; sc = 1; op = 1; z = 30; show = true;
          } else if (abs === 1) {
            tx = off * 58; sc = 0.62; op = 0.6; z = 20; show = true;
          } else {
            tx = off * 96; sc = 0.42; op = 0; z = 10; show = false;
          }

          slide.style.transform = 'translate(-50%, -50%) translateX(' + tx + '%) scale(' + sc + ')';
          slide.style.opacity = op;
          slide.style.zIndex = z;
          slide.style.pointerEvents = show ? 'auto' : 'none';
          slide.classList.toggle('bcf__slide--active', off === 0);
        });

        dots.forEach(function (d, i) {
          d.classList.toggle('bcf__dot--active', i === active);
        });
      }

      function setActive(i) {
        active = ((i % n) + n) % n;
        layout();
      }

      function go(dir) { setActive(active + dir); }

      // Clicks on slides: center -> follow its link, side -> become active
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function (e) {
          if (norm(i - active) === 0) {
            var url = slide.getAttribute('data-link');
            if (url) { window.location.href = url; }
          } else {
            e.preventDefault();
            setActive(i);
          }
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      // Swipe / drag
      var startX = null, dragging = false;
      function down(x) { startX = x; dragging = true; }
      function up(x) {
        if (!dragging || startX === null) return;
        var dx = x - startX;
        if (dx < -40) go(1);
        else if (dx > 40) go(-1);
        dragging = false; startX = null;
      }
      stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      stage.addEventListener('touchend', function (e) { up(e.changedTouches[0].clientX); });
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') down(e.clientX); });
      window.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') up(e.clientX); });

      // Keyboard
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(-1); }
        else if (e.key === 'ArrowRight') { go(1); }
        else if (e.key === 'Enter') {
          var url = slides[active].getAttribute('data-link');
          if (url) window.location.href = url;
        }
      });

      layout();
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-bcf]')).forEach(initCoverflow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector ? e.target.querySelector('[data-bcf]') : null;
      if (s) initCoverflow(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
